import useIPA from '@/auth/jwt/useJwt'
import router from '@/router/index.js'

// initial state
const state = () => ({
  perPage: 5,
  pageOptions: [3, 5, 10],
  totalRows: 1,
  sortOptions: [],
  fields: [
    { key: 'name', label: 'Name', sortable: true },
    { key: 'icon', label: 'Icon'},
    { key: 'desc', label: 'Description'},
    { key: 'is_highlight', label: 'is highlight'},
    { key: 'created_at', label: 'Created At'},
    { key: 'status', label: 'Status', sortable: true },
    { key: 'action', label: 'Action'},
  ],
  items: []
})

// getters
const getters = {}

// actions
const actions = {
  getAll ({ commit }) {
    let param = {status: 'master/specialists/status/AC'}
    useIPA.get(param).then(response => {
      const specialist = {
        rows : response.data.data
      }
      commit('setData', {...specialist})
    })
  },
  getById ({ commit }, id) {
		return new Promise((resolve, reject) => {
      let param = {status: 'master/specialist/' + id}
      useIPA.get(param).then(response => {
          resolve(response.data.data)
      })
    })
  },
  formPostPut ({ commit }, formData) {
		return new Promise((resolve, reject) => {
      const rawData = {
        name: formData.text_1,
        icon: formData.text_2,
        desc: formData.text_3,
        is_highlight: formData.checkbox_4
			}
      const param = { rawData: rawData, url: 'dashboard/master/specialist', id: formData.id}
      useIPA.postput(param)
			.then(response => {
        router.push({ name: 'profession-specialist' })
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	},
  remove ({ commit }, id) {
		return new Promise((resolve, reject) => {
      const param = { url: 'dashboard/master/specialist', id: id }
      useIPA.delete(param)
			.then(response => {
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	}
}

// mutations
const mutations = {
  setData (state, specialist) {
    state.items = specialist.rows
    state.totalRows = specialist.rows.length
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
